/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompletedPaymentDto,
  CompletedPaymentDtoV2,
  ErrorMessage,
  ListActivePaymentDto,
} from '../models';
import {
    CompletedPaymentDtoFromJSON,
    CompletedPaymentDtoToJSON,
    CompletedPaymentDtoV2FromJSON,
    CompletedPaymentDtoV2ToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    ListActivePaymentDtoFromJSON,
    ListActivePaymentDtoToJSON,
} from '../models';

export interface ListActivePaymentsV2Request {
    locationId: string;
}

export interface ListCompletedPaymentsRequest {
    locationId: string;
    page?: number;
}

export interface ListCompletedPaymentsForDeviceRequest {
    deviceId: string;
}

/**
 * 
 */
export class ListActivePaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async listActivePaymentsV2Raw(requestParameters: ListActivePaymentsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListActivePaymentDto>>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling listActivePaymentsV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/locations/{locationId}/active-payments`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListActivePaymentDtoFromJSON));
    }

    /**
     */
    async listActivePaymentsV2(requestParameters: ListActivePaymentsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListActivePaymentDto>> {
        const response = await this.listActivePaymentsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listCompletedPaymentsRaw(requestParameters: ListCompletedPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompletedPaymentDtoV2>>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling listCompletedPayments.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/payments/{locationId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompletedPaymentDtoV2FromJSON));
    }

    /**
     */
    async listCompletedPayments(requestParameters: ListCompletedPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompletedPaymentDtoV2>> {
        const response = await this.listCompletedPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listCompletedPaymentsForDeviceRaw(requestParameters: ListCompletedPaymentsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompletedPaymentDto>>> {
        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling listCompletedPaymentsForDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/devices/{deviceId}/payments`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompletedPaymentDtoFromJSON));
    }

    /**
     */
    async listCompletedPaymentsForDevice(requestParameters: ListCompletedPaymentsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompletedPaymentDto>> {
        const response = await this.listCompletedPaymentsForDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
